"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("../../http");
var Message_1 = require("../Message");
/** A Skip event is sent when an ad is not loaded (i.e. no request sent to ad server)
 * because one or more image is under moderation in the story part
 * in:
 *   adUnitId: the id of the ad that was skipped
 * out:
 * side effects:
 */
var sendSkip = function (adUnitId, adsSkipReason, storyGroup, storyPart) {
    // load common data from the adUnitId cache
    var page = window.ads.page;
    var storyId = window.ads["story_id"];
    var partId = window.ads["part_id"];
    var message = (0, Message_1.getCommonMessageFields)(page, storyId, partId, storyGroup, storyPart);
    message.adunit_id = adUnitId;
    message.placement = adUnitId.split("-")[0];
    message.placement_type = adUnitId.split("-")[0];
    message.page_view_id = window.ads.page_view_id;
    message.ad_skip_reason = adsSkipReason;
    (0, http_1.sendAthaEvent)("ad_skip", message);
    return message["id"];
};
exports.default = sendSkip;
